export const Role = {
    Admin: 'admin',
    User: 'user'
};
